import { useCallback,useEffect, useState } from 'react';

import { useAppDispatch } from 'app/hooks';
import { setRows } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { fetchAclEntries } from 'common/services/api/Acls/AclEntries.thunk';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { handleListFetchError } from 'common/utils/errorHandlers';
import { useSnackbar } from 'notistack';

export const useFetchUserAclEntriesDefaultDataset = (item: {
	tenantId: string,
	userId: string,
	isLicenseRequired?: boolean
}) => {
    const [processing, setProcessing] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { tenantId, userId, isLicenseRequired } = item;

    const fetchAclEntriesDataDefaultDataset = useCallback(() => {
        setProcessing(true);
        dispatch(fetchAclEntries({ tenantId, userId }))
            .unwrap()
            .then((response) => {
                dispatch(setRows(response));
            })
            .catch((error) => {
                dispatch(setRows([]));
                handleListFetchError(extractStatusCode(error.message), 'ACL Entries', enqueueSnackbar);
            })
            .finally(() => {
                setProcessing(false);
            });
    }, [tenantId, userId, isLicenseRequired]);

    useEffect(() => {
        if(isLicenseRequired) {
            return;
        }
        fetchAclEntriesDataDefaultDataset();
    }, [fetchAclEntriesDataDefaultDataset, isLicenseRequired]);

    const refreshUserAclEntriesDefaultDataset = () => fetchAclEntriesDataDefaultDataset();

    return {
        aclEntriesDefaultDatasetProcessing: processing,
        refreshUserAclEntriesDefaultDataset
    };
};
